<template>
    <div class="tab_wrapper font-responsive">
        <div class="tab_contents">
            <div class="tab_visual w-1/2 mobile:w-full">
                <div class="tab_photo-big">
                    <mid class="tab_photo-big--inner" v-if="tab.visual.slides" :component_data="{component:'slides', options:tab.visual.slides_options, images:tab.visual.slides, static_bg:tab.visual.img.src}"></mid>
                    <img class="tab_photo-big--inner" v-else :src="tab.visual.img.src" :alt="tab.visual.img.alt">
                    <span class="tab_photo-big--sidenote" v-if="tab.visual.img.sidenote" v-html="tab.visual.img.sidenote"></span>
                </div>
            </div>
            <article class="tab_caption w-2/5 mobile:w-full">
                <header>
                    <figure class="tab_icon" v-html="tab.icon" :style="customColor(tab)"></figure>
                    <h2 v-html="tab.title"></h2>
                </header>
                <div class="tab_texts">
                    <p v-for="(text, index) in texts(tab)" v-html="text" :key="index"></p>
                </div>
            </article>

        </div>
    </div>
</template>

<script>
export default {
    props: ['component_data'],
    methods: {
      customColor(tab){
        if(tab.icon_color) {
          return "color: "+tab.icon_color+";"
        }
      },
    },
    data(){
        return {
            tab: {
                "title": "",
                "id": "",
                "icon": "",
                "text": "",
                "visual": {
                    "type": "",
                    "img": {
                        "src": "",
                        "alt": ""
                    },
                    "slides": false
                },
                "component": ""
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
            Object.assign(this.tab, this.component_data)
        })
    }
}
</script>

<style scoped>

    .tab_photo-big .tab_photo-big--inner{
        border-top-left-radius: 6em;
        overflow: hidden;
    }
    .tab_photo-big::before
    {
        content: '';
        border-bottom-left-radius: 3em;
        right: -3em;
        background: linear-gradient(to right, #AE0B11, #E41429);
    }
    @media (min-width: 1920px){
        .tab_photo-big {
            width: 620px;
            height: 680px;
        }

        .tab_photo-big::before {
            width: 460px;
            height: 285px;            
        }       
    }

    .tab_wrapper::before { 
        border-top-right-radius: 6em;
    }

</style>
